module.exports = __webpack_public_path__ + "img/vida-logo.5771d11c.png";